import React from 'react';
import LegalDocument from '../components/LegalDocument';
import termsConditions from '../content/legal/terms-conditions.json';

function TermsConditions() {
  return <LegalDocument document={termsConditions} />;
}

export default TermsConditions;
